import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const ANIM_STEPS = [
    {
        desc: 'Clique em um motor livre para iniciar a seleção.',
        states: Array(6).fill('livre'),
        cols: 3,
    },
    {
        desc: 'Motor selecionado. Os vizinhos disponíveis ficam realçados.',
        states: ['first', 'preview', 'livre', 'livre', 'livre', 'livre'],
        cols: 3,
    },
    {
        desc: 'Clique no motor vizinho para formar o par.',
        states: ['grouped', 'grouped', 'livre', 'livre', 'livre', 'livre'],
        cols: 3,
        labels: ['1', '2', '3', '4', '5', '6'],
    },
    {
        desc: 'O par agrupado ocupa uma única célula.',
        states: ['grouped', 'grouped', 'livre', 'livre', 'grouped', 'grouped'],
        cols: 3,
        labels: ['1+2', '', '3', '4', '5+6', ''],
    },
    {
        desc: 'Motores ocupados pedem confirmação antes de agrupar.',
        states: ['ocupado', 'first', 'livre', 'livre', 'livre', 'livre'],
        cols: 3,
    },
    {
        desc: 'Motores bloqueados não podem ser selecionados.',
        states: ['bloqueado', 'livre', 'livre', 'livre', 'bloqueado', 'livre'],
        cols: 3,
    },
    {
        desc: 'Clique sobre um par para desfazer o agrupamento.',
        states: Array(6).fill('livre'),
        cols: 3,
    },
];

const STATE_SX = {
    livre:     { background: '#e8f5e9', borderColor: '#81c784', color: '#1b5e20' },
    first:     { background: '#fff9c4', borderColor: '#f9a825', color: '#e65100' },
    preview:   { background: '#e3f2fd', borderColor: '#64b5f6', color: '#0d47a1' },
    grouped:   { background: '#e0e0e0', borderColor: '#9e9e9e', color: '#212121' },
    ocupado:   { background: '#1b5e20', borderColor: '#1b5e20', color: '#ffffff' },
    bloqueado: { background: '#ffcdd2', borderColor: '#ef9a9a', color: '#b71c1c' },
};

function AnimMotor({ state, label }) {
    const sx = STATE_SX[state] || STATE_SX.livre;

    return (
        <Box sx={{
            width: 28, height: 28, borderRadius: 1,
            border: `1.5px solid ${sx.borderColor}`,
            background: sx.background,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 10, fontWeight: 500, color: sx.color,
            transition: 'all .35s',
        }}>
            {label}
        </Box>
    );
}

export function TutorialMachineSecondStepPanel(props) {
    const [step, setStep] = useState(0);

    useEffect(() => {
        const t = setInterval(() => setStep(s => (s + 1) % ANIM_STEPS.length), 2200);
        return () => clearInterval(t);
    }, []);

    const s = ANIM_STEPS[step];

    return (
        <Box>
            <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '.05em' }}>
                Como agrupar
            </Typography>

            <Paper variant="outlined" sx={{ p: 1.5, mt: 1, mb: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, minHeight: 130, justifyContent: 'center' }}>
                <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${s.cols}, 28px)`, gap: '3px' }}>
                    {s.states.map((st, i) => (
                        <AnimMotor key={i} state={st} label={s.labels ? s.labels[i] : i + 1} />
                    ))}
                </Box>

                <Typography variant="caption" sx={{ textAlign: 'center', color: 'text.secondary', lineHeight: 1.5, minHeight: 36 }}>
                    {s.desc}
                </Typography>
            </Paper>

            <Box sx={{ display: 'flex', gap: .5, justifyContent: 'center', mb: 1.5 }}>
                {ANIM_STEPS.map((_, i) => (
                    <Box key={i} sx={{
                        width: 5, height: 5, borderRadius: '50%',
                        background: i === step ? '#1976d2' : '#bdbdbd',
                        transition: 'background .3s',
                    }} />
                ))}
            </Box>

            <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '.05em' }}>
                Passo a passo
            </Typography>

            <Box component="ol" sx={{ pl: 0, mt: 1, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: .8 }}>
                {[
                    'Clique em um motor livre para selecioná-lo.',
                    'Os motores vizinhos disponíveis ficam realçados.',
                    'Clique no vizinho para formar o par.',
                    'Motores ocupados pedem confirmação antes de agrupar.',
                    'Clique sobre um par para desfazer o agrupamento.',
                    'Pressione Esc para cancelar a seleção.',
                ].map((txt, i) => (
                    <Box key={i} component="li" sx={{ display: 'flex', gap: .8, alignItems: 'flex-start' }}>
                        <Box sx={{
                            width: 16, height: 16, borderRadius: '50%',
                            border: '0.5px solid', borderColor: 'divider',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 9, fontWeight: 500, flexShrink: 0, color: 'text.primary',
                        }}>
                            {i + 1}
                        </Box>

                        <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>{txt}</Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}